export function sourceErrorText(error: unknown): string {
  const value = error as { code?: string; message?: string; diagnostics?: { stage?: string; hostname?: string; protocol?: string } };
  const message = error instanceof Error ? error.message : String(error);
  const d = value?.diagnostics;
  if (value?.code !== 'SOURCE_URL_BLOCKED' || !d || !/^[a-z\d.-]{1,253}$/i.test(d.hostname || '')) return message;
  const stage = d.stage?.startsWith('api-') ? '接口地址' : '音频地址';
  return `音源返回了未支持的${stage}（${d.hostname}），请重试或选择另一个音源。`;
}
